import { render, staticRenderFns } from "./message-popup.vue?vue&type=template&id=7ede28ab"
import script from "./message-popup.vue?vue&type=script&lang=js"
export * from "./message-popup.vue?vue&type=script&lang=js"
import style0 from "./message-popup.vue?vue&type=style&index=0&id=7ede28ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports